<template>
  <span v-if="failure && dense" class="text-caption red--text">
    <v-icon x-small color="red" class="mr-1">mdi-alert-circle</v-icon>{{ failure.step }}<template v-if="failure.reason"> · {{ failure.reason }}</template>
  </span>
  <v-alert v-else-if="failure" type="error" dense text class="text-body-2">
    <div class="font-weight-bold">{{ $t('onboarding.commissioning.plan-failure.title', { step: failure.step }) }}</div>
    <div v-if="failure.reason">{{ failure.reason }}</div>
    <div class="text-caption">{{ $t(resumable ? 'onboarding.commissioning.plan-failure.fix-then-resume' : 'onboarding.commissioning.plan-failure.fix-then-support') }}</div>
  </v-alert>
</template>

<script>
import { planReason, planStepName } from '../planLabels'
import CommissioningMixin from '../CommissioningMixin'

/**
 * Où la mise en service s'est arrêtée : le geste en échec et sa raison, qui dit quoi corriger. Lu dans le plan complet
 * (fiche, tiroir) ou dans son résumé (ligne de la file, `planSummary`).
 */
export default {
  name: 'OrderPlanFailure',

  mixins: [CommissioningMixin],

  props: {
    order: { type: Object, required: true },
    dense: { type: Boolean, default: false },
    resumable: { type: Boolean, default: false },
  },

  computed: {
    failure() {
      const plan = this.order.plan
      if (plan) {
        if (plan.status !== 'failed') return null
        const step = (plan.steps || []).find(s => s.outcome === 'failed')
        if (!step) return null
        return {
          step: planStepName(this, step),
          reason: planReason(this, step.reason, step.reasonParameters, step.reasonLabel),
        }
      }
      const summary = this.order.planSummary
      if (!summary || summary.status !== 'failed') return null
      return {
        step: summary.failedStep || summary.failedStepDescription
          ? planStepName(this, { name: summary.failedStep, description: summary.failedStepDescription, params: summary.failedStepParams })
          : this.$t('onboarding.commissioning.plan-failure.unknown-step'),
        reason: this.planReasonLabel(summary.failedReason, summary.failedReasonParameters),
      }
    },
  },
}
</script>
